import { useId, useRef } from 'react'

//* Style
import CallToActionStyle from './style'

//* Components
import Container from 'components/common/Container'
import Text from 'components/common/Text'
import Button from 'components/common/Button'
import Animate from 'components/common/Animate'

const CallToAction = ({ first, title, description, bgColor, link, buttonText }) => {
	const clipPathId = useId()

	//! Refs
	const wave = useRef()

	return (
		<CallToActionStyle clipPathId={clipPathId}>
			<Container first={first} section>
				<div className={`content bg${bgColor}`}>
					<Text tag={first ? 'h1' : 'h2'} className={'h2 font-soundscape-bold title '} text={title} />
					<Text tag={'h3'} className={'h6 font-helvetica description '} text={description} />
					<Button url={link} target={'_blank'} className={'call-to-action-button'} type={'icon-aside'} text={buttonText} />
					<svg className='wave-svg'>
						<clipPath id={clipPathId} clipPathUnits='objectBoundingBox'>
							<path d='M1,0.023 s-0.043,-0.037,-0.064,-0.017 s-0.038,0.041,-0.05,0.038 S0.829,0.032,0.798,0.061 s-0.053,0.124,-0.067,0.166 S0.636,0.398,0.611,0.427 s-0.079,0.063,-0.097,0.086 s-0.028,0.048,-0.06,0.064 s-0.114,0.085,-0.169,0.137 S0.098,0.774,0,0.659 V1 H1'></path>
						</clipPath>
					</svg>
					<Animate params={{ bottomToTop: [wave] }}>
						<div className='wave' ref={wave}></div>
					</Animate>
				</div>
			</Container>
		</CallToActionStyle>
	)
}

CallToAction.defaultProps = {
	buttonText: 'visitWebsite',
}

export default CallToAction
